export enum ChartViewMode {
  Monthly = 'monthly',
  Weekly = 'weekly',
  Daily = 'daily',
}
